import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { getAlerts, markAlertsSeen } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";

const notify = (a) => {
  if (a.kind === "entry_filled") {
    toast.success(`Auto-order filled: ${a.verb} ${a.shares} ${a.symbol} at $${a.price}`, {
      description: a.stop ? `Protective stop placed at $${a.stop}.` : "Now in My Picks.",
      duration: 15000, id: `alert-${a.id}`, classNames: { description: "!text-bt-text-secondary" },
    });
    return;
  }
  if (a.kind === "stop_near") {
    toast.warning(`${a.symbol} is ${a.pct}% from your stop`, {
      description: `Now $${a.price} · stop $${a.stop}. It will sell automatically if reached (${a.result >= 0 ? "+" : "-"}$${Math.abs(a.result).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}).`,
      duration: 15000, id: `alert-${a.id}`, classNames: { description: "!text-bt-text-secondary" },
    });
    return;
  }
  const who = a.source === "woodrow" ? "Woodrow's short" : "Your short";
  toast.warning(`Short squeeze: ${a.symbol} +${a.pct}%`, {
    description: `${who} is moving against you: $${a.entry} → $${a.price} (open loss -$${Math.abs(a.loss).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}). Consider covering or setting a stop-loss.`,
    duration: 20000,
    id: `alert-${a.id}`,
    classNames: { description: "!text-bt-text-secondary" },
  });
};

export const AlertNotifier = () => {
  const { user } = useAuth();
  const busy = useRef(false);
  useEffect(() => {
    if (!user) return;
    const check = async () => {
      if (busy.current) return;
      busy.current = true;
      try {
        const { data } = await getAlerts();
        if (data?.length) {
          data.forEach(notify);
          await markAlertsSeen(data.map(a => a.id));
        }
      } catch {}
      busy.current = false;
    };
    check();
    const t = setInterval(check, 120000);
    return () => clearInterval(t);
  }, [user]);
  return null;
};
